export const urlRegex = /((?:https?|ftp):\/\/[^\s/$.?#].[^\s)"(]*)/g